import React from 'react'

const DropdownMenuButton = ({ index, buttons }) => {
  return (
    <div className="dropdown">
      <i
        className="bi bi-three-dots-vertical"
        role="button"
        id={`dropdownMenuButton-${index}`}
        data-bs-toggle="dropdown"
        aria-expanded="false"
        style={{ fontSize: '1.2rem', cursor: 'pointer' }}
      />
      <div
        className="dropdown-menu p-2"
        aria-labelledby={`dropdownMenuButton-${index}`}
        style={{ minWidth: '125px', width: 'fit-content' }}
      >
        {buttons.map(({ label, icon, onClick, className = '', style = {} }, i) => (
          <button
            key={i}
            className={`btn w-100 ${className} ${i > 0 ? 'mt-2' : ''}`}
            onClick={onClick}
            style={style}
          >
            <i className={`bi bi-${icon} me-1`} />
            {label}
          </button>
        ))}
      </div>
    </div>
  )
}

export default DropdownMenuButton
